import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=60dae052&scoped=true"
import script from "./DurationInput.vue?vue&type=script&lang=js"
export * from "./DurationInput.vue?vue&type=script&lang=js"
import style0 from "./DurationInput.vue?vue&type=style&index=0&id=60dae052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dae052",
  null
  
)

export default component.exports